import React from 'react';
import { QualificationStatus } from './QualificationStatus';
import { Card, renderRow, TextLink } from 'components';
import { IApplicantQualificationDetails } from 'components/models';
import CertPreview from './cert-preview.jpg';
import styles from './QualificationInfoDetails.module.scss';

const QualificationInfoDetails = ({
    qualificationDetails, onBackClick, cardCategory, cardTitle, withoutBorder,
}: IProps) => {
    const {
        expireDate, issueDate, title, qecFullName, narkPageUrl, certificateUrl,
    } = qualificationDetails;

    return (
        <Card
          title={title}
          onClickBack={onBackClick}
          titleClassName="mb-0"
          withoutBorder={withoutBorder}
          withBackButton
          withoutPadding
          smallTitle
        >
            <Card
              title={cardTitle || 'Информация по квалификации'}
              category={cardCategory || 'Список квалификаций, присвоенных вам, как эксперту'}
              withoutBorder
            >
                {renderRow('КВАЛИФИКАЦИЯ', title)}
                {renderRow('ЦОК', qecFullName)}
                {renderRow('ДАТА ПРИСВОЕНИЯ', issueDate.format('DD.MM.YYYY'))}
                {renderRow('ДАТА ОКОНЧАНИЯ', expireDate.format('DD.MM.YYYY'))}
                {renderRow('СТАТУС', <QualificationStatus expireDate={expireDate} />)}
                {renderRow('ЗАПИСЬ В РЕЕСТРЕ', <TextLink text="Ссылка на запись" link={narkPageUrl} withIcon />)}
                {certificateUrl && renderRow('СВИДЕТЕЛЬСТВО', <a className={styles.qualificationImage} href={certificateUrl} target="__blank"><img src={CertPreview} alt="certPreview" /></a>)}
            </Card>
        </Card>
    );
};

export default QualificationInfoDetails;

interface IProps {
    qualificationDetails: IApplicantQualificationDetails;
    cardTitle?: string;
    cardCategory?: string;
    withoutBorder?: boolean;
    onBackClick: () => void;
}
